<template>
	<main :class="{ 'main': true, 'with-sidebar': true, 'locked': showModal }">
		<div class="container" v-show="visible">
			<div class="row">
				<div class="col-lg-12">
					<div class="page-header">
						<div class="button-wrapper-left">
							<span class="button-full" @click="toggleModal">{{ $t('button.add') }}</span>
						</div>
						<search-bar class="page-header-controls"></search-bar>
					</div>
				</div>
			</div>
			<div class="row table-wrap">
				<div class="col-lg-12">
					<div class="table-scroll">
						<vuetable ref="customersList" :api-url="url"
							:fields="columns"
							:muti-sort="true"
							:append-params="moreParams"
							pagination-path="pagination"
							@vuetable:pagination-data="onPaginationData"
							@vuetable:load-success="onTableLoaded"
							>
						</vuetable>
						<vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
					</div>
				</div>
			</div>
		</div>

		<customer-modal :data="customer" :show="showModal" @closed="onClosed"></customer-modal>

	</main>
</template>
<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import Vuetable from '@/components/vuetable/Vuetable'
  import VuetablePagination from '@/components/vuetable/VuetablePagination'
  import SearchBar from './SearchBar'
  import CustomerCell from './CustomerCell'
  import CategoriesCell from './CategoriesCell'
  import CustomerActions from './CustomerActions'
  import CustomerModal from './CustomerModal'

  Vue.component('customer-actions', CustomerActions)
  Vue.component('categories-cell', CategoriesCell)
  Vue.component('customer-cell', CustomerCell)

  export default {
    components: {
      Vuetable,
      VuetablePagination,
      SearchBar,
      CustomerModal
    },
    name: 'CustomersPage',
    data () {
      return {
        visible: false,
        showModal: false,
        url: '/v1/customers',
        moreParams: {},
        customer: {},
        columns: [
          {
            title: 'Id',
            name: 'id',
            sortField: 'id',
            visible: false
          },
          {
            name: '__component:customer-cell',
            title: this.$t('label.person_name'),
            sortField: 'name',
            titleClass: 'width-4'
          },
          {
            name: '__component:categories-cell',
            title: this.$t('label.category'),
            titleClass: 'width-4',
            dataClass: 'table-cell-hide'
          },
          {
            title: this.$t('label.phone'),
            name: 'phone',
            sortField: 'phone',
            titleClass: 'width-2',
            callback: 'formatPhone'
          },
          {
            name: '__component:customer-actions',
            title: '',
            titleClass: 'width-2',
            dataClass: 'table-controls'
          }
        ]
      }
    },
    mounted () {
      this.$events.$on('customer-edited', eventData => this.onEdit(eventData))
      this.$events.$on('customer-deleted', eventData => this.onDelete(eventData))
      this.$events.$on('customer-search', eventData => this.onSearch(eventData))
    },
    methods: {
      transform: function (data) {
        // transform api data to fit our needs for pagination
        let transformed = {}

        transformed.pagination = {
          total: data.meta.total,
          per_page: data.meta.per_page,
          current_page: data.meta.current_page,
          last_page: data.meta.last_page,
          next_page_url: data.links.next,
          prev_page_url: data.links.prev,
          from: data.meta.from,
          to: data.meta.to
        }

        transformed.data = data.data
        return transformed
      },
      onEdit (data) {
        this.customer = _.cloneDeep(data.customer)
        this.showModal = true
      },
      onSearch (searchParams) {
        this.moreParams = searchParams
        Vue.nextTick(() => this.$refs.customersList.reload())
      },
      onDelete () {
        Vue.nextTick(() => this.$refs.customersList.reload())
      },
      onClosed (data) {
        if (data.updated && data.updated === true) {
          Vue.nextTick(() => this.$refs.customersList.reload())
        }
        this.showModal = data.show
        document.body.classList.toggle('lock')
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.customersList.changePage(page)
      },
      onTableLoaded () {
        this.visible = true
      },
      toggleModal () {
        this.customer = {}
        this.showModal = !this.showModal
        document.body.classList.toggle('lock')
      },
      formatPhone (val) {
        if (val) {
          return '<a href="tel:' + val + '">' + val + '</a>'
        }
        return val
      }
    },
    destroyed () {
      this.$events.off('customer-search')
      this.$events.off('customer-edited')
      this.$events.off('customer-deleted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/Customers.vue